export const links = {
  privacy:
    "https://res.cloudinary.com/df3ajcohw/image/upload/v1640722474/assets/d17drx6sfofrdtfhug6d.pdf",
  terms:
    "https://res.cloudinary.com/df3ajcohw/image/upload/v1640722478/assets/gieyynntunjb8hl8gmcz.pdf",
};
